import { type GridFilterInitialState } from '@mui/x-data-grid-pro';
import type { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { useSearchParams } from 'react-router-dom';

import {
  deserializeFilterModel,
  deserializePagination,
  deserializeSortModel,
} from '../../utils/serializers';

export const useDataGridInitialState = (
  initialState: GridInitialStatePro | undefined,
  { pagination, initialPageSize }: { pagination: boolean | undefined; initialPageSize: number }
): GridInitialStatePro | undefined => {
  const [searchParams] = useSearchParams();

  // Parse the page and pageSize from the URL
  const { page, pageSize } = deserializePagination(searchParams, initialPageSize);

  // Parse the sorting from the URL
  const sortModel = deserializeSortModel(searchParams);

  // Parse the filter from the URL
  const filterModel = deserializeFilterModel(searchParams);
  const filter: GridFilterInitialState | undefined = filterModel
    ? {
        filterModel: {
          items: filterModel?.items || [],
          logicOperator: filterModel?.logicOperator,
          quickFilterValues: filterModel?.quickFilterValues,
          quickFilterLogicOperator: filterModel?.quickFilterLogicOperator,
        },
      }
    : undefined;

  const sorting =
    (sortModel && { sortModel }) || (initialState?.sorting && { ...initialState?.sorting });

  return {
    ...initialState,
    pagination: pagination
      ? {
          paginationModel: {
            pageSize,
            page,
          },
        }
      : undefined,
    sorting,
    filter: filter || initialState?.filter,
  };
};
